/*
 * Texte der Kurse (Kursverwaltung, KI-Kurs, Kurs-Auswertung, Einstellung
 * „Kurse & Gutschrift"). Eingebunden in `./index.js` **nach** den großen
 * Sprachdateien — hier steht deshalb nur, was es dort noch nicht gibt; ein
 * gleichlautender Schlüssel würde dort Übersetztes überschreiben.
 */

const de = {
	// Kursbereich (Schüler:innen, Vorschau)
	Courses: 'Kurse',
	Course: 'Kurs',
	'Loading…': 'Wird geladen …',
	'The course could not be loaded.': 'Der Kurs konnte nicht geladen werden.',
	'There are no courses for you at the moment.': 'Für dich gibt es gerade keinen Kurs.',
	'Courses are switched off.': 'Kurse sind ausgeschaltet.',
	'Preview — progress is not saved and there is no certificate.':
		'Vorschau – der Fortschritt wird nicht gespeichert, und es gibt keine Urkunde.',
	'{{n}} modules': '{{n}} Module',
	'{{n}} lessons': '{{n}} Lektionen',
	'Certificate at the end': 'Urkunde am Ende',
	'Completed on {{date}}': 'Abgeschlossen am {{date}}',
	'{{percent}} % done': '{{percent}} % erledigt',
	'To the quiz': 'Zum Quiz',
	'Watch again': 'Noch einmal ansehen',
	'Continue watching': 'Weiter ansehen',
	Start: 'Starten',
	'Preparing…': 'Wird erstellt …',
	'Download certificate': 'Urkunde herunterladen',
	'Module {{n}}': 'Modul {{n}}',
	'{{done}} of {{total}} watched': '{{done}} von {{total}} gesehen',
	'Scroll left': 'Nach links blättern',
	'Scroll right': 'Nach rechts blättern',
	Watched: 'Gesehen',
	Reading: 'Lesetext',
	Video: 'Video',
	'Watch all lessons of this module first.': 'Zuerst alle Lektionen dieses Moduls ansehen.',
	Quiz: 'Quiz',
	'Quiz · {{n}} questions': 'Quiz · {{n}} Fragen',
	'Passed ({{correct}} of {{total}})': 'Bestanden ({{correct}} von {{total}})',
	'Not passed yet — try again': 'Noch nicht bestanden – nochmal versuchen',
	'Ready to start': 'Bereit',
	'Unlocks after all lessons': 'Nach allen Lektionen freigeschaltet',
	'{{m}} min': '{{m}} Min.',
	'{{h}} h': '{{h}} Std.',
	'{{h}} h {{m}} min': '{{h}} Std. {{m}} Min.',
	'Back to the course': 'Zurück zum Kurs',
	'This lesson could not be loaded.': 'Diese Lektion konnte nicht geladen werden.',
	'No video has been uploaded for this lesson yet.': 'Zu dieser Lektion ist noch kein Video hochgeladen.',
	'Module finished': 'Modul geschafft',
	'Now show what you have learned.': 'Jetzt zeig, was du gelernt hast.',
	'Next episode in {{n}}': 'Nächste Folge in {{n}}',
	'Play now': 'Jetzt abspielen',
	'Counts as watched from {{n}} % — skipping ahead does not count.':
		'Gilt ab {{n}} % als gesehen – Vorspulen zählt nicht.',
	Transcript: 'Transkript',
	'Mark as read': 'Gelesen',
	'Next lesson': 'Nächste Lektion',
	Episodes: 'Folgen',
	Passed: 'Bestanden',
	'No lessons yet.': 'Noch keine Lektionen.',
	'The quiz could not be loaded.': 'Das Quiz konnte nicht geladen werden.',
	'Question {{n}} of {{total}}': 'Frage {{n}} von {{total}}',
	'Next question': 'Weiter',
	'Try the quiz again': 'Nochmal versuchen',
	'Previous question': 'Zurück',
	'Several answers can be correct.': 'Mehrere Antworten können richtig sein.',
	'Choose one answer.': 'Wähle eine Antwort.',
	'Not available in the preview.': 'In der Vorschau nicht möglich.',
	'Checking…': 'Wird geprüft …',
	'Submit answers': 'Antworten abgeben',
	'Passed! The module is complete.': 'Bestanden! Das Modul ist geschafft.',
	'Not passed yet — you need {{n}} correct answers. Watch the videos again and try once more.':
		'Noch nicht bestanden – du brauchst {{n}} richtige Antworten. Sieh dir die Videos noch einmal an und versuch es erneut.',
	'Next module': 'Nächstes Modul',
	Correct: 'Richtig',
	'Congratulations — course completed!': 'Gratulation – Kurs geschafft!',
	'You have finished all modules of „{{title}}“. Your certificate is ready.':
		'Du hast alle Module von „{{title}}“ abgeschlossen. Deine Urkunde ist fertig.',
	'Check code': 'Prüfcode',

	// Lehrkraft
	Certificate: 'Urkunde',
	Name: 'Name',
	'{{lessons}} of {{total}} lessons · {{modules}} of {{mtotal}} quizzes':
		'{{lessons}} von {{total}} Lektionen · {{modules}} von {{mtotal}} Quizzen',
	'Here you can see how far the students of your Junior Companies have got. You can watch the courses yourself in the preview — progress and certificates belong to the students.':
		'Hier sehen Sie, wie weit die Schüler:innen Ihrer Junior Companies sind. Die Kurse können Sie selbst in der Vorschau ansehen – Fortschritt und Urkunde gehören den Schüler:innen.',
	'Watch „{{title}}“ (preview)': '„{{title}}“ ansehen (Vorschau)',
	'The course overview could not be loaded.': 'Die Kursübersicht konnte nicht geladen werden.',
	'As soon as you supervise a Junior Company, its students appear here.':
		'Sobald Sie eine Junior Company betreuen, erscheinen hier ihre Schüler:innen.',
	'credit from {{n}} completions': 'Gutschrift aus {{n}} Abschlüssen',
	cap: 'Obergrenze',
	'Deducted from the last invoice of the school year.': 'Wird von der letzten Rechnung des Schuljahres abgezogen.',

	// Prüfseite
	'Certificate check': 'Urkunde prüfen',
	'This certificate is genuine.': 'Diese Urkunde ist echt.',
	'Awarded to': 'Ausgestellt auf',
	'Completed on': 'Abgeschlossen am',
	'Issued by': 'Ausgestellt von',
	'No certificate with this check code was found. Please compare the code with the one on the certificate.':
		'Zu diesem Prüfcode gibt es keine Urkunde. Bitte vergleichen Sie den Code mit dem auf dem Blatt.',

	// Kursverwaltung
	'Course management': 'Kursverwaltung',
	'Course evaluation': 'Kurs-Auswertung',
	'New course': 'Neuer Kurs',
	'The course is created as a draft. Students only see it once it is published.':
		'Der Kurs entsteht als Entwurf. Schüler:innen sehen ihn erst, wenn er veröffentlicht ist.',
	Create: 'Anlegen',
	'Please enter a title.': 'Bitte einen Titel angeben.',
	For: 'Für',
	Modules: 'Module',
	Lessons: 'Lektionen',
	Questions: 'Fragen',
	'{{n}} not reviewed': '{{n}} nicht abgenommen',
	Completions: 'Abschlüsse',
	Changed: 'Geändert',
	'Courses with videos, quizzes and a certificate. Who sees a course is set per course (company types); whether courses are switched on at all and what a completion is worth on the invoice is set under Settings → Courses & credit.':
		'Kurse mit Videos, Quiz und Urkunde. Wer einen Kurs sieht, steht am Kurs (Unternehmensformen); ob es Kurse überhaupt gibt und was ein Abschluss auf der Rechnung wert ist, steht unter Einstellungen → Kurse & Gutschrift.',
	Draft: 'Entwurf',
	Published: 'Veröffentlicht',
	Archived: 'Archiviert',
	'Basic data': 'Grunddaten',
	'Modules & lessons': 'Module & Lektionen',
	'Delete course?': 'Kurs löschen?',
	'The course with all modules, lessons, videos and questions is deleted. A course that has already been completed cannot be deleted — archive it instead.':
		'Der Kurs wird mit allen Modulen, Lektionen, Videos und Fragen gelöscht. Ein Kurs, den schon jemand abgeschlossen hat, lässt sich nicht löschen – archivieren Sie ihn stattdessen.',
	'To the course list': 'Zur Kursliste',
	Saved: 'Gespeichert',
	'The image may be at most 5 MB.': 'Das Bild darf höchstens 5 MB groß sein.',
	Subtitle: 'Untertitel',
	Description: 'Beschreibung',
	'Shown large on the course page next to the cover image.': 'Steht groß auf der Kursseite neben dem Titelbild.',
	'Cover image': 'Titelbild',
	'Uploading…': 'Wird hochgeladen …',
	'JPG, PNG or WebP, at most 5 MB, ideally 16:9 (e.g. 1920 × 1080).':
		'JPG, PNG oder WebP, höchstens 5 MB, am besten 16:9 (etwa 1920 × 1080).',
	Visibility: 'Sichtbarkeit',
	'Draft: only visible here. Published: students see it. Archived: hidden, completions and certificates remain.':
		'Entwurf: nur hier sichtbar. Veröffentlicht: Schüler:innen sehen ihn. Archiviert: ausgeblendet, Abschlüsse und Urkunden bleiben.',
	'For which company types?': 'Für welche Unternehmensformen?',
	'Published, but for no company type — nobody sees the course.':
		'Veröffentlicht, aber für keine Unternehmensform – niemand sieht den Kurs.',
	'Quiz and completion': 'Quiz und Abschluss',
	'Questions per quiz': 'Fragen je Quiz',
	'Drawn at random from the question pool of the module.': 'Zufällig gezogen aus dem Fragenpool des Moduls.',
	'Passed from (correct answers)': 'Bestanden ab (richtige Antworten)',
	'Video counts as watched from (%)': 'Video gilt als gesehen ab (%)',
	'Skipping ahead does not count.': 'Vorspulen zählt nicht.',
	'A completion counts towards the credit on the invoice': 'Ein Abschluss zählt für die Gutschrift auf der Rechnung',
	'Title on the certificate': 'Titel auf der Urkunde',
	'Text on the certificate': 'Text auf der Urkunde',
	'One or two sentences on what the course covered. Name, date, modules and check code are added automatically.':
		'Ein, zwei Sätze, worum es im Kurs ging. Name, Datum, Module und Prüfcode kommen von selbst dazu.',
	Save: 'Speichern',
	'Undo changes': 'Änderungen verwerfen',
	'Questions per quiz: 1 to 20.': 'Fragen je Quiz: 1 bis 20.',
	'The pass mark must be between 1 and the number of questions per quiz.':
		'Die Hürde muss zwischen 1 und der Zahl der Fragen je Quiz liegen.',
	'Watched from: 50 to 100 %.': 'Gesehen ab: 50 bis 100 %.',
	'New module': 'Neues Modul',
	'This course has no modules yet.': 'Dieser Kurs hat noch keine Module.',
	'Add module': 'Modul hinzufügen',
	'Delete module?': 'Modul löschen?',
	'The module is deleted with all its lessons, videos and questions.':
		'Das Modul wird mit allen Lektionen, Videos und Fragen gelöscht.',
	'New reading': 'Neuer Lesetext',
	'New video': 'Neues Video',
	'Module title': 'Titel des Moduls',
	'Move up': 'Nach oben',
	'Move down': 'Nach unten',
	'Delete module': 'Modul löschen',
	'Save module': 'Modul speichern',
	'Add video lesson': 'Video-Lektion hinzufügen',
	'Add reading': 'Lesetext hinzufügen',
	'Delete lesson?': 'Lektion löschen?',
	'The lesson and its video are deleted. Progress already recorded for it is lost.':
		'Die Lektion und ihr Video werden gelöscht. Der dazu gespeicherte Fortschritt geht verloren.',
	'Please choose an MP4 video.': 'Bitte ein MP4-Video wählen.',
	'The video may be at most {{n}} MB.': 'Das Video darf höchstens {{n}} MB groß sein.',
	'Video uploaded': 'Video hochgeladen',
	'Video uploaded — Bunny is preparing it, this takes a few minutes.': 'Video hochgeladen — Bunny bereitet es auf, das dauert ein paar Minuten.',
	'The video could not be uploaded. Please try again.': 'Das Video konnte nicht hochgeladen werden. Bitte noch einmal versuchen.',
	'Video missing': 'Video fehlt',
	unsaved: 'ungespeichert',
	'Delete lesson': 'Lektion löschen',
	Title: 'Titel',
	'Short description': 'Kurzbeschreibung',
	uploaded: 'hochgeladen',
	'none yet': 'noch keines',
	Thumbnail: 'Vorschaubild',
	'16:9, e.g. 640 × 360.': '16:9, etwa 640 × 360.',
	'Shown below the video; also helps with accessibility.': 'Steht unter dem Video; hilft auch bei der Barrierefreiheit.',
	Text: 'Text',
	'Save lesson': 'Lektion speichern',
	'Please enter the question.': 'Bitte die Frage eintragen.',
	'At least two answers are needed.': 'Es braucht mindestens zwei Antworten.',
	'Mark at least one answer as correct.': 'Mindestens eine Antwort als richtig markieren.',
	'With single choice exactly one answer is correct.': 'Bei Einfachauswahl ist genau eine Antwort richtig.',
	'Not all answers can be correct.': 'Es können nicht alle Antworten richtig sein.',
	'Create modules first — questions belong to a module.': 'Zuerst Module anlegen – Fragen gehören zu einem Modul.',
	'{{n}} questions in the pool, {{m}} per quiz': '{{n}} Fragen im Pool, {{m}} je Quiz',
	'Fewer questions than per quiz ({{n}}) — the quiz of this module cannot start yet.':
		'Weniger Fragen als je Quiz ({{n}}) – das Quiz dieses Moduls kann noch nicht starten.',
	'Add question': 'Frage hinzufügen',
	'Delete question?': 'Frage löschen?',
	'Question {{n}}': 'Frage {{n}}',
	'Several answers can be correct': 'Mehrere Antworten können richtig sein',
	'Reviewed by Junior Achievement': 'Von Junior Achievement abgenommen',
	correct: 'richtig',
	'Answer {{n}}': 'Antwort {{n}}',
	'Remove answer': 'Antwort entfernen',
	'Add answer': 'Antwort hinzufügen',
	'Explanation (shown after submitting)': 'Erklärung (erscheint nach dem Abgeben)',
	'Save question': 'Frage speichern',

	// Auswertung
	'At least one completion': 'Mindestens ein Abschluss',
	'All members completed': 'Alle Mitglieder fertig',
	'Cap reached': 'Obergrenze erreicht',
	'No completion yet': 'Noch kein Abschluss',
	'Junior Company or school': 'Junior Company oder Schule',
	'School year': 'Schuljahr',
	Members: 'Mitglieder',
	Started: 'Begonnen',
	Completed: 'Abgeschlossen',
	'Credit earned': 'Gutschrift erworben',
	'On invoice': 'Auf Rechnung',
	'Students completed': 'Schüler:innen fertig',
	'{{started}} started · {{eligible}} eligible': '{{started}} begonnen · {{eligible}} berechtigt',
	'Companies with a completion': 'Companies mit Abschluss',
	'of {{n}} eligible': 'von {{n}} berechtigten',
	Credit: 'Gutschrift',
	'{{applied}} on invoices · {{pending}} pending': '{{applied}} auf Rechnungen · {{pending}} offen',
	'{{n}} stays as credit': '{{n}} bleibt Guthaben',
	'Certificates issued': 'Urkunden ausgestellt',
	'A click on a row shows the students of the Junior Company with their status per module.':
		'Ein Klick auf eine Zeile zeigt die Schüler:innen der Junior Company mit ihrem Stand je Modul.',
	'Where the course gets stuck': 'Wo der Kurs hakt',
	Module: 'Modul',
	'Ø attempts': 'Ø Versuche',
	'Hardest questions': 'Schwierigste Fragen',
	Question: 'Frage',
	Asked: 'Gestellt',
	Wrong: 'Falsch',
	'No students.': 'Keine Schüler:innen.',

	// Einstellung
	'Courses & credit': 'Kurse & Gutschrift',
	'Example: courses on, credit on, 10 € per completion, at most 100 € per Junior Company.':
		'Beispiel: Kurse ein, Gutschrift ein, 10 € je Abschluss, höchstens 100 € je Junior Company.',
	'The credit is deducted from the last invoice of the school year (JC: annual report, JCC/JBC: the only invoice). What goes beyond the invoice stays as credit and is not paid out. Completions after the last report has been submitted no longer count.':
		'Die Gutschrift wird von der letzten Rechnung des Schuljahres abgezogen (JC: Jahresabschluss, JCC/JBC: die einzige Rechnung). Was über die Rechnung hinausgeht, bleibt Guthaben und wird nicht ausgezahlt. Abschlüsse nach dem Einreichen des letzten Berichts zählen nicht mehr.',
	'Students complete courses with videos and quizzes in the app and receive a certificate. Each completion with certificate can be credited to the Junior Company. Which courses exist and for which company types they apply is set under Course management.':
		'Schüler:innen absolvieren Kurse mit Videos und Quiz in der Anwendung und erhalten eine Urkunde. Jeder Abschluss mit Urkunde kann der Junior Company gutgeschrieben werden. Welche Kurse es gibt und für welche Unternehmensformen sie gelten, steht in der Kursverwaltung.',
	'Courses switched on': 'Kurse eingeschaltet',
	'Class exercise': 'Klassenübung',
	'To reflect on': 'Zum Nachdenken',
	'{{from}}–{{to}} min in class': '{{from}}–{{to}} Min. in der Klasse',
	'{{n}} min read': '{{n}} Min. Lesezeit',
	'Course area switched on (menu item “Courses” for students and teachers)':
		'Kursbereich eingeschaltet (Menüpunkt „Kurse“ für Schüler:innen und Lehrkräfte)',
	'Courses for students': 'Kurse für Schüler:innen',
	'As long as courses are switched off above, no course is shown — even a published one.':
		'Solange der Kursbereich oben ausgeschaltet ist, wird kein Kurs angezeigt — auch kein veröffentlichter.',
	published: 'veröffentlicht',
	'no company type yet': 'noch keine Unternehmensform',
	'Completions: {{n}}': 'Abschlüsse: {{n}}',
	'Course published': 'Kurs veröffentlicht',
	'Course set back to draft': 'Kurs zurück auf Entwurf gesetzt',
	'Skills4Retail learning path': 'Skills4Retail-Lernstrecke',
	'switched in its own setting': 'geschaltet in der eigenen Einstellung „Skills4Retail-Konzept“',
	'before activation': 'vor der Aktivierung',
	'before the first report': 'vor dem ersten Bericht',
	off: 'aus',
	'Create course': 'Kurs anlegen',
	'switched off': 'ausgeschaltet',
	'Switched off. Students and teachers see no courses; certificates already issued remain valid.':
		'Ausgeschaltet. Schüler:innen und Lehrkräfte sehen keine Kurse; ausgestellte Urkunden bleiben gültig.',
	'Credit on the invoice': 'Gutschrift auf der Rechnung',
	'Credit switched on': 'Gutschrift eingeschaltet',
	'Credits already earned remain if the credit is switched off; new completions no longer count from then on. A change of amount applies to invoices created afterwards.':
		'Wird die Gutschrift ausgeschaltet, bleiben schon erworbene Gutschriften stehen; neue Abschlüsse zählen ab dann nicht mehr. Eine Betragsänderung gilt für Rechnungen, die danach entstehen.',
	'Per completion (€)': 'Je Abschluss (€)',
	'Cap per Junior Company (€, empty = none)': 'Obergrenze je Junior Company (€, leer = keine)',
	Reminder: 'Erinnerung',
	'Remind the teacher … days before the deadline of the last report if completions are missing (0 = no reminder)':
		'Lehrkraft … Tage vor der Frist des letzten Berichts erinnern, wenn Abschlüsse fehlen (0 = keine Erinnerung)',
	'Reminder days': 'Tage vor der Frist',
	'Amount per completion for {{type}}: 0 to 1000 €.': 'Betrag je Abschluss für {{type}}: 0 bis 1000 €.',
	'Cap for {{type}}: empty (no cap) or 0 to 100000 €.': 'Obergrenze für {{type}}: leer (keine) oder 0 bis 100000 €.',
	'Reminder: 0 to 90 days (0 = no reminder).': 'Erinnerung: 0 bis 90 Tage (0 = keine).',

	// Mitteilungen
	'Course „{{title}}“ completed — congratulations!': 'Kurs „{{title}}“ geschafft – Gratulation!',
	'Your certificate is ready.': 'Deine Urkunde ist fertig.',
	'To the certificate': 'Zur Urkunde',
	'One student has completed „{{title}}“': 'Eine Schüler:in hat „{{title}}“ abgeschlossen',
	'{{n}} students have completed „{{title}}“': '{{n}} Schüler:innen haben „{{title}}“ abgeschlossen',
	'To the course overview': 'Zur Kursübersicht',
	'Maximum course credit reached': 'Volle Kurs-Gutschrift erreicht',
	'Your Junior Company has earned the full credit of {{amount}} for „{{title}}“. It is deducted from the last invoice of the school year.':
		'Eure Junior Company hat die volle Gutschrift von {{amount}} für „{{title}}“ erreicht. Sie wird von der letzten Rechnung des Schuljahres abgezogen.',

	// Rechnungen
	'{{n}} course completions credited': '{{n}} Kursabschlüsse gutgeschrieben',

	// Kurse von TalentsLounge (eingebettet, seit 01.11.2026)
	'Courses (test)': 'Kurse (Test)',
	Recommended: 'Empfohlen',
	'Certificate and credit for your Junior Company': 'Urkunde und Gutschrift für eure Junior Company',
	'Open course': 'Kurs öffnen',
	'Continue course': 'Kurs fortsetzen',
	'Back to the courses': 'Zurück zu den Kursen',
	'The course is starting…': 'Der Kurs wird gestartet …',
	'The course could not be started.': 'Der Kurs konnte nicht gestartet werden.',
	'You have completed this course. Your certificate is ready.':
		'Du hast den Kurs abgeschlossen. Deine Urkunde liegt bereit.',
	'As soon as you have passed all three module quizzes and finished every lesson, your certificate appears here.':
		'Sobald du alle drei Modul-Quizze bestanden und jede Lektion erledigt hast, liegt hier deine Urkunde bereit.',
	'Provided by TalentsLounge': 'Bereitgestellt von TalentsLounge',
	'Courses of your Junior Companies': 'Kurse eurer Junior Companies',
	'Free for your classes': 'Kostenlos für Ihre Klassen',
	'Typing licence': 'Tastatur-Führerschein',
	'Ten-finger typing in short rounds — free on TalentsLounge, for your whole class.':
		'Zehn-Finger-Schreiben in kurzen Runden – kostenlos auf TalentsLounge, für Ihre ganze Klasse.',
	'More courses': 'Mehr Kurse',
	'Courses for your lessons, orderable via the Marktplatz Lern-Apps of the BMB.':
		'Kurse für Ihren Unterricht, bestellbar über den Marktplatz Lern-Apps des BMB.',
	'Opens TalentsLounge in a new tab': 'Öffnet TalentsLounge in einem neuen Tab',
	'Students start the course themselves in the Junior app. Here you see who has completed it.':
		'Die Schüler:innen starten den Kurs selbst in der Junior-App. Hier sehen Sie, wer ihn abgeschlossen hat.',
	'not yet completed': 'noch nicht abgeschlossen'
}

/*
 * Englisch: Die meisten Schlüssel sind schon der englische Satz. Hier stehen
 * nur die, deren Schlüssel kein fertiger Satz ist.
 */
const enOverrides = {
	'Next question': 'Next',
	'Try the quiz again': 'Try again',
	'Previous question': 'Back',
	'Loading…': 'Loading …',
	'Preparing…': 'Preparing …',
	'Checking…': 'Checking …',
	'Uploading…': 'Uploading …',
	cap: 'cap',
	correct: 'correct'
}

export const coursesGer = de
export const coursesEn = Object.fromEntries(Object.keys(de).map(key => [key, enOverrides[key] ?? key]))
